import React from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
export function useScrollYPosition() {
    var _a = React.useState(0), y = _a[0], setY = _a[1];
    useScrollPosition(function (_a) {
        var currPos = _a.currPos;
        setY(currPos.y);
    }, []);
    return y;
}
